import { render, staticRenderFns } from "./ExamImport.vue?vue&type=template&id=6d358f3e"
import script from "@/controllers/custom/exam/exam-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/exam/exam-import.js?vue&type=script&lang=js&external"
import style0 from "./ExamImport.vue?vue&type=style&index=0&id=6d358f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports